/** Homepage sections (below hero) — mirrors PHP site_copy_page_defaults(). */
export const BRAND_COPY_DEFAULTS = {
  name: 'Saloni Designs',
  logo_url: '/saloni-logo.png',
};

export const FOOTER_COPY_DEFAULTS = {
  explore_heading: 'Explore',
  connect_heading: 'Connect',
  shipping_link_label: 'Shipping & returns',
  copyright_suffix: 'All rights reserved.',
};

export const HOME_COPY_DEFAULTS = {
  hero_badge: 'Handcrafted',
  hero_image_focal_x: 50,
  hero_image_focal_y: 28,
  hero_trust_1: 'Handcrafted',
  hero_trust_2: 'Ships across India',
  hero_trust_3: '',
  hero_picks_label: "Editor's picks",
  about_cta_label: 'Learn More About Us',
  about_cta_url: '/about',
  about_eyebrow: 'Our story',
  next_exhibition_badge: 'Next exhibition',
  next_exhibition_cta_label: 'See schedule',
  collections_title: 'Shop collections',
  collections_eyebrow: '',
  collections_lead: '',
  collections_action: 'View all',
  shop_by_style_title: 'Shop by style',
  shop_by_style_eyebrow: '',
  shop_by_style_lead: '',
  curated_title: 'Curated looks',
  curated_subtitle_featured: 'Hand-picked in Admin → Site → Featured.',
  curated_subtitle_default: 'Auto-filled from catalog — pick products in Admin → Site → Featured.',
  featured_title: 'Featured products',
  featured_eyebrow: '',
  featured_lead: '',
  featured_action: 'Shop all',
  recently_viewed_title: 'Recently viewed',
  recently_viewed_eyebrow: '',
  recently_viewed_lead: '',
  recently_viewed_action: 'Browse shop',
  blog_view_all_label: 'View all stories',
  blog_eyebrow: 'Journal',
  instagram_title: 'Follow us',
  instagram_eyebrow: '@floraljewelry_salonidesigns',
  instagram_subtitle: '',
  instagram_button: 'Visit our Instagram profile',
  instagram_empty: 'Product photos from your catalog will appear here.',
  exhibitions_eyebrow: 'Meet us in person',
  exhibitions_title: 'Exhibition schedule',
  exhibitions_subtitle:
    'Find when we are near you—browse by month or filter by city. We sell most of our collection at these shows.',
};

export const ABOUT_COPY_DEFAULTS = {
  story_heading: 'Our story',
  values_title: 'What we stand for',
  values_subtitle: 'The principles behind every piece we make.',
  values: [
    {
      icon: '🎨',
      title: 'Artisanal craftsmanship',
      desc: 'Every piece is hand-finished with meticulous attention to detail.',
    },
    {
      icon: '💝',
      title: 'Sacred traditions',
      desc: 'Honoring rituals and cultural meaning in modern celebrations.',
    },
    {
      icon: '✨',
      title: 'Modern elegance',
      desc: 'Contemporary designs that feel personal and festive.',
    },
  ],
  cta_lead: 'Ready to find your perfect piece?',
  cta_primary_label: 'Get in touch',
  cta_secondary_label: 'Browse the shop',
};

export const CONTACT_COPY_DEFAULTS = {
  eyebrow: 'Saloni Designs',
  hero_title: 'Get in touch',
  hero_subtitle: "We'd love to hear from you — custom orders, questions, or just hello.",
  hero_whatsapp_button: 'WhatsApp us',
  hero_shop_button: 'Browse the shop',
  reach_title: 'Reach us',
  reach_subtitle: 'Choose what works best for you.',
  form_title: 'Send a message',
  form_subtitle: 'Custom orders, bulk gifting, or general questions.',
  form_submit: 'Send message',
  hours_title: 'Business hours',
  cards: [
    { icon: '📞', title: 'Call us', desc: 'Speak directly with our team', link_label: '' },
    { icon: '✉️', title: 'Email us', desc: 'Questions or special requests', link_label: '' },
    { icon: '📍', title: 'Visit us', desc: 'Based in Gujarat, India', link_label: '' },
    { icon: '💬', title: 'WhatsApp', desc: 'Quick messages and order updates', link_label: 'Chat with us' },
  ],
};

export const PAGE_COPY_DEFAULTS = {
  brand: BRAND_COPY_DEFAULTS,
  footer: FOOTER_COPY_DEFAULTS,
  home: HOME_COPY_DEFAULTS,
  about: ABOUT_COPY_DEFAULTS,
  contact: CONTACT_COPY_DEFAULTS,
};
